import { FieldValues, Path, PathValue, UseFormReturn } from "react-hook-form";

const ADDRESS_FIELDS = ["address", "city", "postalCode", "region", "country"];

export const applyContactPrefill = <T extends FieldValues>(
  form: Pick<UseFormReturn<T>, "getFieldState" | "setValue">,
  contactInfo: Record<string, string | undefined>
) => {
  const isAddressTouched = ADDRESS_FIELDS.some((field) => form.getFieldState(field as Path<T>).isDirty);

  Object.entries({ region: undefined, ...contactInfo }).forEach(([key, value]) => {
    const field = key as Path<T>;
    const isKeptAddressField = isAddressTouched && ADDRESS_FIELDS.includes(key);
    const isRegion = key === "region";
    const isRegionWithoutCountry = isRegion && !contactInfo.country;
    if ((!value && !isRegion) || isRegionWithoutCountry || isKeptAddressField || form.getFieldState(field).isDirty) {
      return;
    }
    form.setValue(field, (value ?? "") as PathValue<T, Path<T>>);
  });
};
